import React from "react";

/* ── Image imports ── */
import HeroBgImg     from "../../../asset/images/core-values/hero-bg.webp";
import BcSepIcon     from "../../../asset/images/about/breadcrumb-separator.svg";
import HungryImg     from "../../../asset/images/core-values/hungry.webp";
import BrutallyImg   from "../../../asset/images/core-values/brutally-honest.webp";
import InnovativeImg from "../../../asset/images/core-values/innovative.webp";
import DesiringImg   from "../../../asset/images/core-values/desiring.webp";
import PurposeBgImg  from "../../../asset/images/core-values/purpose-bg.webp";
import CtaPersonImg  from "../../../asset/images/core-values/cta-person.webp";

/* ── Data — imageLeft drives alternating layout logic ── */
const VALUES = [
  {
    id: 1,
    keyword: "HUNGRY",
    phonetic: "{ hʌŋ.ɡri }",
    tagline: "WE FIGHT FOR EVERY INCH.",
    text: "We are nimble warriors who never, ever give up, as the inches are everywhere. We are dependable & deliver on our commitments. We are about the future & add value through superior technological solutions that are relentlessly reliable. We are ethical & act with integrity in all of our dealings, – always! We always make our work fun, no matter what",
    image: HungryImg,
    imageLeft: false,
  },
  {
    id: 2,
    keyword: "BRUTALLY HONEST ",
    phonetic: "{ ɒn.ɪst }",
    tagline: "WE SHOW RADICAL CANDOUR.",
    text: "We strive to be a great place to work by allowing all opinions to shine. We are always caring & honest in our dealings with everyone. We provide constructive feed-forward using only facts & not emotions. Our arguments encompass the good & the difficult (Good-Bad-Good!). We speak-up and don’t allow the poor performance of others to let the team down. We demonstrate the leadership we want shown to us. WE MAKE WORK FUN (as we spend 80% of waking hours here",
    image: BrutallyImg,
    imageLeft: true,
  },
  {
    id: 3,
    keyword: "INNOVATIVE",
    phonetic: "{ in-uh-vey-tiv }",
    tagline: "WE ARE INNOVATIVE & THEREFORE FEARLESS.",
    text: "We constantly analyse our markets & develop nimble, innovative solutions that are relentlessly reliable and idiot proof, which address the key pain areas of our customers in a refreshing new way . We work in 90 day cycles to develop, test and industrialise our ideas. We are a learning organisation & encourage making new mistakes. We learn from our mistakes and try no to make the same mistake twice. We reward those who push the boundaries of their (and our) comfort zones. We always make our work fun, no matter what!",
    image: InnovativeImg,
    imageLeft: false,
  },
  {
    id: 4,
    keyword: "DESERVING",
    phonetic: "{ dɪˈzɜː.vɪŋ }",
    tagline: "WE ALWAYS DESERVE OUR PROFITS & SECURE OUR CASH.",
    text: "People are the purpose, but profit & cash are the means. We never cheat to make a profit. We work with ethics & integrity in all that we do. We present nimble, technically superior & innovative solutions that are relentlessly reliable to ensure we always deserve a profit. We measure our cost correctly & ensure that margins cover not just costs, but our welfare. We measure our risks & only offer commercial terms that protect our cash-flows. We make every deal count. Every sale! Every time! Every day! We always spend less than we earn. Then, we have fun, no matter what.",
    image: DesiringImg,
    imageLeft: true,
  },
];

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .cv { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══════════════════════════════════════════
     1. HERO
  ══════════════════════════════════════════ */
  .cv-hero {
    position: relative;
    width: 100%;
    height: 460px;
    overflow: hidden;
  }

  .cv-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
    display: block;
  }

  .cv-hero-overlay {
    position: absolute;
    inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.70) 0%,
    //   rgba(0,0,0,0.35) 55%,
    //   rgba(0,0,0,0.05) 100%
    // );
  }

  .cv-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }

  .cv-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #ffffff;
    line-height: 120%;
    margin-bottom: 15px;
  }

  .cv-hero-divider {
    width: 559px;
    height: 2px;
    background: #EB2019;
    border: none;
    margin-bottom: 15px;
  }

  .cv-hero-desc {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    line-height: 160%;
    max-width: 501px;
  }

  /* ══════════════════════════════════════════
     2. BREADCRUMB
  ══════════════════════════════════════════ */
  .cv-breadcrumb {
    width: 100%;
    padding: 40px 0 0 0;
  }

  .cv-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .cv-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    display: flex;
    align-items: center;
    transition: color 0.15s;
  }

  .cv-bc-item:hover { color: #EB2019; }

  .cv-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  .cv-bc-item.active {
    color: #202020;
    font-weight: 500;
  }

  /* ══════════════════════════════════════════
     SHARED INNER
  ══════════════════════════════════════════ */
  .cv-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* ══════════════════════════════════════════
     3. CORE VALUES GRID SECTION
     2x2 grid — image top, text below, white bg
  ══════════════════════════════════════════ */
  .cv-values-section {
    padding: 80px 0 120px 0;
  }

  .cv-section-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #202020;
    text-align: center;
    margin-bottom: 60px;
    line-height: 140%;
  }

  /* 2x2 grid */
  .cv-values-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 104px 30px;
  }

  /* Each card: image full-width on top, text below */
  .cv-value-card {
    display: flex;
    flex-direction: column;
  }

  .cv-value-img {
    width: 100%;
    height: 350px;
    object-fit: cover;
    display: block;
    flex-shrink: 0;
    border-radius: 10px;
  }

  .cv-value-body {
    padding-top: 30px;
    flex: 1;
  }

  .cv-value-title {
    font-family: 'Poppins', sans-serif;
    font-size: 28px;
    font-weight: 400;
    color: #202020;
    line-height: 120%;
    margin-bottom: 15px;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }

  .cv-value-phonetic {
    font-family: 'Poppins', sans-serif;
    font-size: 28px;
    font-weight: 400;
    color: #202020;
    line-height: 130%;
    margin-bottom: 15px;
    font-style: italic;
  }

  .cv-value-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 500;
    color: #EB2019;
    line-height: 140%;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-bottom: 20px;
  }

  .cv-value-para {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
  }

  /* ══════════════════════════════════════════
     4. CORE PURPOSE — full-width pink banner
  ══════════════════════════════════════════ */
  .cv-purpose-section {
    padding: 0 0 120px 0;
  }

  .cv-purpose-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #202020;
    text-align: center;
    margin-bottom: 60px;
    line-height: 140%;
  }

  .cv-purpose-banner {
    position: relative;
    width: 1200px;
    margin : 0 auto;
    height: 600px;
    background: #FADADD;
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .cv-purpose-banner-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    opacity: 0.25;
  }

  .cv-play-btn {
    position: relative;
    z-index: 2;
    width: 72px;
    height: 72px;
    background: #EB2019;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: none;
    transition: background 0.2s, transform 0.2s;
    flex-shrink: 0;
    pointer-events: none;
  }

  .cv-play-btn svg { display: block; margin-left: 5px; }

  /* ══════════════════════════════════════════
     5. CTA SECTION
  ══════════════════════════════════════════ */
  
  .cv-cta-section {
  position: relative;
  width: 100%;
  min-height: 450px;
  overflow: hidden;
  display: flex;
  align-items: center;
  margin-bottom: 120px;
}
.cv-cta-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  display: block;
}

.cv-cta-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
}

.cv-cta-inner {
  position: relative;
  z-index: 2;
  max-width: 1600px;
  margin: 0 auto;
  padding: 0px 102px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.cv-cta-text { flex: 0 0 278px; }

  .cv-cta-label {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 400;
    color: #FFFFFF;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 15px;
    display: block;
  }

  .cv-cta-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 500;
    color: #ffffff;
    line-height: 120%;
    margin-bottom: 30px;
  }

  .cv-cta-btn {
    display: inline-block;
    background: #EB2019;
    color: #ffffff;
    font-family: 'DM Sans', sans-serif;
    font-size: 16px;
    font-weight: 500;
    padding: 14px 36px;
    border-radius: 10px;
    text-decoration: none;
    border: none;
    cursor: pointer;
    transition: background 0.2s;
    line-height: 1;
  }

  .cv-cta-btn:hover { background: #c91a13; }

  .cv-cta-person {
    flex: 0 0 380px;
    height: 450px;
    object-fit: cover;
    object-position: top center;
    display: block;
    align-self: flex-end;
  }

  // //////////////////////////////////
  .cv-purpose-banner {
  position: relative;
  width: 1200px;
  margin: 0 auto;
  height: 600px;
  border-radius: 10px;
  overflow: hidden;
}

.cv-purpose-video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

  /* ══════════════════════════════════════════
     RESPONSIVE — TABLET (max-width: 768px)
  ══════════════════════════════════════════ */
  @media (max-width: 768px) {
    .cv-hero             { height: 350px; }
    .cv-hero-content     { padding: 0 32px; }
    .cv-hero-title       { font-size: 30px; margin-bottom: 16px; }
    .cv-hero-divider     { width: 200px; }
    .cv-hero-desc        { font-size: 14px; }

    .cv-breadcrumb       { padding: 28px 0 0 0; }
    .cv-breadcrumb-inner { padding: 0 32px; }
    .cv-inner            { padding: 0 32px; }

    .cv-values-section   { padding: 48px 0 48px 0; }
    .cv-section-title    { font-size: 24px; margin-bottom: 24px; }
    .cv-values-grid      { grid-template-columns: 1fr 1fr; gap: 32px 24px; }
    .cv-value-img        { height: 200px; }
    .cv-value-body {     padding-top: 24px;}
    .cv-value-title      { font-size: 18px;     margin-bottom: 12px; }
    .cv-value-phonetic { font-size: 18px; }
    .cv-value-subtitle { font-size: 16px;     margin-bottom: 14px; }
    .cv-value-para       { font-size: 12px; }
    .cv-purpose-banner {  width: 500px;}

    .cv-purpose-section  { padding: 0 0 48px 0; }
    .cv-purpose-title    { font-size: 24px; margin-bottom: 28px; }
    .cv-purpose-banner   { height: 300px; }
    .cv-play-btn         { width: 60px; height: 60px; }

    .cv-cta-section      { min-height: 360px; }
    .cv-cta-inner        { padding: 0px 32px; }
    .cv-cta-title        { font-size: 36px; margin-bottom: 24px; }
    .cv-cta-person       { flex: 0 0 240px; height: 360px; }
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — MOBILE (max-width: 480px)
  ══════════════════════════════════════════ */
  @media (max-width: 480px) {
    .cv-hero             { height: 400px; background-poistion:center center;}
    .cv-hero-content     { padding: 0 16px; }
    .cv-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .cv-hero-divider     { width: 180px; margin-bottom: 15px; }
    .cv-hero-desc        { font-size: 14px; max-width: 308px; }

    .cv-breadcrumb       { padding: 32px 0 0 0; }
    .cv-breadcrumb-inner { padding: 0 16px; gap: 14px; }
    .cv-bc-item          { font-size: 14px; }
    .cv-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .cv-inner            { padding: 0 16px; }

    .cv-values-section   { padding: 60px 0 60px 0; }
    .cv-section-title    { font-size: 24px; margin-bottom: 30px; }
        .cv-value-body {         padding-top: 20px;}
    .cv-values-grid      { grid-template-columns: 1fr; gap: 30px; }
    .cv-value-img        { height: 200px; }
    .cv-value-title      { font-size: 20px; margin-bottom: 10px;  }
    .cv-value-phonetic   { font-size: 20px; }
    .cv-value-subtitle   { font-size: 16px; margin-bottom: 10px;}
    .cv-value-para       { font-size: 14px; }

    .cv-purpose-section  { padding: 0 0 60px 0; }
    .cv-purpose-title    { font-size: 24px; margin-bottom: 20px; }
    .cv-purpose-banner   { height: 200px; border-radius: 8px; width:370px; }
    .cv-play-btn         { width: 56px; height: 56px; }

    .cv-cta-section      { min-height: unset; margin-bottom: 60px;}
    .cv-cta-inner        { flex-direction: column; align-items: flex-start;  padding: 48px 16px 0 16px; }
    .cv-cta-label {     font-size: 16px; line-height:120%;}
    .cv-cta-title        { font-size: 24px; margin-bottom: 29px; }
    .cv-cta-btn          { font-size: 14px; padding: 12px 28px; margin-bottom: 32px; }
    .cv-cta-person       { flex: none; width: 100%; height: 300px; }
  }
`;

const PlayIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="#ffffff">
    <path d="M8 5v14l11-7z" />
  </svg>
);

export default function CoreValues() {
  return (
    <div className="cv">
      <style>{CSS}</style>

      {/* ══ 1. HERO ══ */}
      <section className="cv-hero">
        <img className="cv-hero-bg" src={HeroBgImg} alt="Core Values Hero" />
        <div className="cv-hero-overlay" />
        <div className="cv-hero-content">
          <h1 className="cv-hero-title">Core Values</h1>
          <hr className="cv-hero-divider" />
          <p className="cv-hero-desc">
            Transforming your passion into something extraordinary lies inside each of us.
          </p>
        </div>
      </section>

      {/* ══ 2. BREADCRUMB ══ */}
      <nav className="cv-breadcrumb" aria-label="Breadcrumb">
        <div className="cv-breadcrumb-inner">
          <a href="/" className="cv-bc-item">Home</a>
          <span className="cv-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/about-us" className="cv-bc-item">About Us</a>
          <span className="cv-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="cv-bc-item active">Core Values</span>
        </div>
      </nav>

      {/* ══ 3. CORE VALUES GRID
           Logic from reference: VALUES array with imageLeft flag,
           but UI is white 2x2 grid — image top, text below
      ══ */}
      <section className="cv-values-section">
        <div className="cv-inner">
          <h2 className="cv-section-title">Our Core Values</h2>
          <div className="cv-values-grid">
            {VALUES.map((val) => (
              <div className="cv-value-card" key={val.id}>
                <img className="cv-value-img" src={val.image} alt={val.keyword} />
                <div className="cv-value-body">
                  <p className="cv-value-title">
                    {val.keyword} <span className="cv-value-phonetic">{val.phonetic}</span>
                  </p>
                  <p className="cv-value-subtitle">{val.tagline}</p>
                  <p className="cv-value-para">{val.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ 4. CORE PURPOSE — single full-width banner with play button ══ */}
      {/* <section className="cv-purpose-section">
        <div className="cv-inner">
          <h2 className="cv-purpose-title">Our Core Purpose – Helping People Get Home Safe</h2>
          <div
            className="cv-purpose-banner"
            onClick={() => {
              const v = document.getElementById("cv-purpose-vid");
              if (v) { v.paused ? v.play() : v.pause(); }
            }}
          >
            <video
              id="cv-purpose-vid"
              src="YOUR_VIDEO_URL_HERE"
              poster={PurposeBgImg}
              preload="metadata"
              playsInline
              style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", opacity: 0.25 }}
            />
            <div className="cv-play-btn">
              <PlayIcon />
            </div>
          </div>
        </div>
      </section> */}
      {/* ══ 4. CORE PURPOSE — YouTube video ══ */}
<section className="cv-purpose-section">
  <div className="cv-inner">
    <h2 className="cv-purpose-title">Our Core Purpose – Helping People Get Home Safe</h2>
    <div className="cv-purpose-banner">
      <iframe
        className="cv-purpose-video"
        src="https://www.youtube.com/embed/TPu2n1ttzQY"
        title="Our Core Purpose"
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </div>
  </div>
</section>

      
      {/* ══ 5. CTA ══ */}
<section className="cv-cta-section">
  <img className="cv-cta-bg" src={CtaPersonImg} alt="" />
  <div className="cv-cta-overlay" />
  <div className="cv-cta-inner">
    <div className="cv-cta-text">
      <span className="cv-cta-label">Career</span>
      <h2 className="cv-cta-title">Be A Part Of Ador</h2>
      <a href="/careers" className="cv-cta-btn">Read More</a>
    </div>
  </div>
</section>

    </div>
  );
}